module.exports = __webpack_public_path__ + "img/logo.2161d7d8.png";